module.exports = __webpack_public_path__ + "img/sld_scb_2_green.94304397.svg";